// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventPlaysGetBody = {
  eventId: string;
};

export type typeEventPlaysGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    layout: "drives" | "plays";
    periods: {
      periodNumber?: number | null;
      label: string;
      plays: {
        entryId: string;
        clockLabel?: string | null;
        description: string;
        teamId?: string | null;
        homeScore?: number | null;
        awayScore?: number | null;
        isScoringPlay: boolean;
      }[];
      drives: {
        driveKey: string;
        teamId?: string | null;
        label?: string | null;
        startClockLabel?: string | null;
        playCount?: number | null;
        yards?: number | null;
        timeOfPossession?: string | null;
        endHomeScore?: number | null;
        endAwayScore?: number | null;
        isScoringDrive: boolean;
        plays: {
          entryId: string;
          clockLabel?: string | null;
          description: string;
          teamId?: string | null;
          homeScore?: number | null;
          awayScore?: number | null;
          isScoringPlay: boolean;
        }[];
      }[];
    }[];
    refreshAfterSeconds: number;
    sportKey?:
      | "football"
      | "basketball"
      | "baseball"
      | "hockey"
      | "golf"
      | "soccer"
      | "mma"
      | null;
  };
};

export type typeEventPlaysGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlaysGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventPlaysGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventPlaysGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventPlaysGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventPlaysGetBody);
  }

  return async function postEventPlaysGet(
    payload: typeEventPlaysGetBody,
  ): Promise<typeEventPlaysGetOutput200 | typeEventPlaysGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventPlaysGet" failed before calling the network. #991f70753369`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#991f70753369" },
        },
        data: null,
      } as typeEventPlaysGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/plays-get`,
      httpMethod: "POST",
      options,
    })) as typeEventPlaysGetOutput200 | typeEventPlaysGetOutput400;
  };
}
